import React from 'react';
import CustomTitle1 from '../../atoms/customTitle1/index';
import CustomTitle2 from '../../atoms/customTitle2/index';

interface ICustomtitleConfig {
  title?: string;
  rightText?: string;
  bgColor?: string;
  titleIcon?: string;
  titleType?: string;
}
interface ICustomtitleProps {
  id: string;
  pid?: string;
  children?: any[];
  config: ICustomtitleConfig;
  clickTo?: (type: string, path1: string, path2: string, componentId: string) => void;
}
const CustomTitle = (props: ICustomtitleProps) => {
  const { config, clickTo } = props;
  return (
    config.titleType === 'btnTitle' ? <CustomTitle2 {...config} clickTo={clickTo}></CustomTitle2> :
      <CustomTitle1 {...config} clickTo={clickTo}></CustomTitle1>
  );
};

export default CustomTitle;